import { render, staticRenderFns } from "./registerButtons.vue?vue&type=template&id=683f9cd4&"
import script from "./registerButtons.vue?vue&type=script&lang=js&"
export * from "./registerButtons.vue?vue&type=script&lang=js&"
import style0 from "./registerButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports